import { render } from "./detail.vue?vue&type=template&id=a203c91e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=a203c91e&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a203c91e"],['__file',"src/views/order/products/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a203c91e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a203c91e', __exports__)) {
    console.log('reload')
    api.reload('a203c91e', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=a203c91e&scoped=true", () => {
    console.log('re-render')
    api.rerender('a203c91e', render)
  })

}


export default __exports__